import React, { useEffect } from 'react';
import { api } from '../../../../config/modules/api';
import './styles.css';

const Manutencao = () => {
  useEffect(() => {
    const interval = setInterval(() => {
      check();
    }, 5000);

    return () => clearInterval(interval);
  }, []);
  async function check() {
    try {
      const response = await api.get('/api/companies');

      if (response.status === 200) {
        console.log('Manuntencao desligada');
        window.location.replace('/login');
      }
    } catch (err) {
      console.error(err);
    }
  }
  return (
    <div className='container-fluid'>
      <div className='row'>
        {/* <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100vw;
          height: 100dvh;

        "
      >  */}
        <div
          style={{
            display: 'flex',
            height: '100dvh',
            width: '100%',
            alignItems: 'center',
            flexWrap: 'wrap',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          <div style={{ padding: '0 10px' }}>
            <div className='text-center'>
              <h1>:) Oops!</h1>
              <h2>Sistema temporariamente indisponível</h2>
              <h1>Voltaremos em breve!</h1>
            </div>

            <p>
              Informamos que nosso site está temporariamente fora do ar para manutenção programada.
              Estamos trabalhando diligentemente para melhorar sua experiência e garantir que nossos
              serviços estejam sempre funcionando com a máxima eficiência e segurança.
            </p>
            <p>
              Durante esse período, alguns recursos podem estar indisponíveis. Pedimos desculpas por
              qualquer inconveniente e agradecemos sua compreensão. Fique tranquilo, estamos nos
              esforçando para restabelecer o acesso o mais rápido possível.
            </p>
            <p>
              Durante esse período, alguns recursos podem estar indisponíveis. Pedimos desculpas por
              qualquer inconveniente e agradecemos sua compreensão. Fique tranquilo, estamos nos
              esforçando para restabelecer o acesso o mais rápido possível.
            </p>
            <p>- O time</p>
          </div>
          <div>
            <div className='error-actions'>
              <a
                href='mailto:ti@ecometria.eco.br'
                style={{ marginTop: '10px' }}
                className='btn btn-link btn-lg'
              >
                <span className='glyphicon glyphicon-envelope'> </span>
                ti@ecometria.eco.br
              </a>
            </div>
          </div>

          <div
            style={{
              position: 'absolute',
              zIndex: 0,
              margin: 'auto',
              opacity: 0.4,
              width: '100%',
              height: '100%',
              textAlign: 'center',
            }}
          >
            <svg
              className='svg-box'
              viewBox='0 0 837 1045'
              version='1.1'
              xmlns='http://www.w3.org/2000/svg'
              style={{ width: '100%', height: '100%' }}
            >
              <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
                <path
                  d='M353,9 L626.664028,170 L626.664028,487 L353,642 L79.3359724,487 L79.3359724,170 L353,9 Z'
                  id='Polygon-1'
                  stroke='#3bafda'
                  strokeWidth='6'
                ></path>
                <path
                  d='M78.5,529 L147,569.186414 L147,648.311216 L78.5,687 L10,648.311216 L10,569.186414 L78.5,529 Z'
                  id='Polygon-2'
                  stroke='#7266ba'
                  strokeWidth='6'
                ></path>
                <path
                  d='M773,186 L827,217.538705 L827,279.636651 L773,310 L719,279.636651 L719,217.538705 L773,186 Z'
                  id='Polygon-3'
                  stroke='#f76397'
                  strokeWidth='6'
                ></path>
                <path
                  d='M639,529 L773,607.846761 L773,763.091627 L639,839 L505,763.091627 L505,607.846761 L639,529 Z'
                  id='Polygon-4'
                  stroke='#00b19d'
                  strokeWidth='6'
                ></path>
                <path
                  d='M281,801 L383,861.025276 L383,979.21169 L281,1037 L179,979.21169 L179,861.025276 L281,801 Z'
                  id='Polygon-5'
                  stroke='#ffaa00'
                  strokeWidth='6'
                ></path>
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Manutencao;
